import { render, staticRenderFns } from "./AssociacaoPerfilUsuarioForm.vue?vue&type=template&id=2e18545c"
import script from "./AssociacaoPerfilUsuarioForm.vue?vue&type=script&lang=js"
export * from "./AssociacaoPerfilUsuarioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports